export const minioBaseUrl = 'https://vbflw.be:9000/vbflw';
export const baseApiUrl = 'https://vbflw.be:8443';